module.exports = __webpack_public_path__ + "static/Image01@2x-f1659bc760031cd08f66ccbf0663de19.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/features/design/photos/Image01@2x.jpg
// module id = 894
// module chunks = 227233210825294 244429959259914